import { render } from "./EmptyPage.vue?vue&type=template&id=72d0a842&scoped=true"
const script = {}

import "./EmptyPage.vue?vue&type=style&index=0&id=72d0a842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d0a842"]])

export default __exports__